export const MIN_ASSESSMENT_VIEWPORT_WIDTH = 1025;

/** Assessments require a viewport wider than the tablet breakpoint. */
export function isAssessmentViewportSupported(viewportWidth: number): boolean {
  return Number.isFinite(viewportWidth) && viewportWidth >= MIN_ASSESSMENT_VIEWPORT_WIDTH;
}
